const getCsrfToken = () => {
  const token = document.querySelector('meta[name="csrf-token"]');
  return token ? token.content : null;
};

const handleResponse = async (response) => {
  if (response.ok) {
    // Handle cases with no content (e.g., 204 No Content on DELETE)
    if (response.status === 204 || response.headers.get('Content-Length') === '0') {
      return null;
    }
    return response.json();
  } else {
    const errorData = await response.json().catch(() => ({
      error: `Request failed with status ${response.status}`,
    }));

    // Extract a user-friendly error message from Rails' typical error responses
    const errorMessage = errorData.error || (errorData.errors && Object.values(errorData.errors).flat().join(', ')) || 'An unknown error occurred.';

    const error = new Error(errorMessage);
    error.status = response.status;
    error.data = errorData;
    throw error;
  }
};

const apiService = {
  get: async (url) => {
    const response = await fetch(url, {
      headers: { 'Accept': 'application/json' },
    });
    return handleResponse(response);
  },

  post: async (url, body) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
      body: JSON.stringify(body),
    });
    return handleResponse(response);
  },

  patch: async (url, body) => {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
      body: JSON.stringify(body),
    });
    return handleResponse(response);
  },

  delete: async (url) => {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
    });
    return handleResponse(response);
  },
};

export default apiService;